const getStore = (state, storeName) => state[storeName] || {};

export const extractField = (obj, path) => {
    if (Array.isArray(obj)) {
        return obj
            .map(o => {
                return extractField(o, path);
            })
            .filter(e => {
                return e !== undefined;
            })
            .pop();
    }
    const currentKey = path[0];
    if (Object.keys(obj).indexOf(currentKey) >= 0) {
        const pathLength = path.length;
        const currentObj = obj[currentKey];
        if (pathLength > 1) {
            return extractField(currentObj, path.slice(1, pathLength));
        }
        return currentObj;
    }
    return undefined;
};

const getFieldFromState = (state, storeName, fieldName) => {
    let value = [];

    if (state && storeName && fieldName) {
        const fieldValue = extractField(getStore(state, storeName), fieldName.split('.'));

        if (Array.isArray(fieldValue)) {
            value = value.concat(fieldValue);
        } else {
            fieldValue !== undefined ? value.push(fieldValue) : (value = []);
        }
    }

    return value;
};

const getFieldOrDefault = (state, storeName, fieldName = '', _default) => {
    if (fieldName) {
        const res = fieldName
            .split('.')
            .reduce((res, cur) => (typeof res === 'object' ? res[cur] : res), state[storeName]);
        return typeof res !== 'undefined' ? res : _default;
    }
    return _default;
};

export const selectors = {
    getFieldFromState,
    getFieldOrDefault,
    extractField,
    getStore,
};
